// extracted by mini-css-extract-plugin
export default {"container":"Trending_container__REqtb","card":"Trending_card__BcHAh","iconWrapper":"Trending_iconWrapper__IbjBj","text":"Trending_text__HpGLw"};